// import Moment from "moment";
import React from "react";
let CryptoJS = require("crypto-js");
import SecureStorage from "secure-web-storage";

import * as signalR from "@microsoft/signalr";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import $ from "jquery";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import semver from "semver";
import Cookies from "js-cookie";
import { TENANT_ID } from "../Constant/Constant.js";

export const setConnectionNotif = (userid) => {
  const url_api = URL_api();
  const connect = new HubConnectionBuilder()
    .withUrl(url_api + "notfy/hubs?username=" + userid)
    .configureLogging(signalR.LogLevel.Information)
    //.withAutomaticReconnect()
    .build();

  return connect;
};
export const setBuilderNotif = (connection, userid) => {
  if (connection) {
    // console.log(connection)
    connection
      .start()
      .then(() => {
        console.log("Connection Succesfully Established!");
        connection.invoke("SetConnectionId", userid, connection.connectionId);
        // connection.on("ReceiveMessage", (message) => {
        //   // console.log(message.message);
        //   // notification.info({
        //   //   message: "New Notification",
        //   //   description: message.message,
        //   //   duration: 10,
        //   // });
        // });
        connection.onclose(async () => {
          await connection.invoke("RemoveConnection", connection.connectionId);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
};
export const secureStorage = () => {
  const SECRET_KEY = "password_onehcm123";

  return new SecureStorage(localStorage, {
    hash: function hash(key) {
      try {
        key = CryptoJS.SHA256(key, SECRET_KEY);

        return key.toString();
      } catch (error) {
        console.warn(
          "[secureStorage] Hashing failed, clearing corrupted localStorage entries.",
          error
        );
        return "";
      }
    },
    encrypt: function encrypt(data) {
      try {
        data = CryptoJS.AES.encrypt(data, SECRET_KEY);

        data = data.toString();

        return data;
      } catch (error) {
        console.warn(
          "[secureStorage] Encryption failed, clearing corrupted localStorage entries.",
          error
        );
        return "";
      }
    },
    decrypt: function decrypt(data) {
      try {
        data = CryptoJS.AES.decrypt(data, SECRET_KEY);

        data = data.toString(CryptoJS.enc.Utf8);

        return data;
      } catch (error) {
        console.warn(
          "[secureStorage] Decryption failed, clearing corrupted localStorage entries.",
          error
        );
        // Remove all secure-storage entries that may be corrupted so they get re-fetched
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i);
          // SecureStorage hashes its keys; remove any entry whose value looks like a CryptoJS ciphertext
          if (k && localStorage.getItem(k)?.startsWith("U2FsdGVkX1")) {
            keysToRemove.push(k);
          }
        }
        keysToRemove.forEach((k) => localStorage.removeItem(k));
        return "";
      }
    },
  });
};

export const encryptData = (text) => {
  try {
    let encoded = base64_encode(text);

    return encoded;
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
};

export const decryptData = (text) => {
  try {
    let decode = base64_decode(text);

    return decode;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

export const getEnvironment = () => {
  const environment = process.env.REACT_APP_ENV;
  return environment;
};

export const isLocalTesting = () =>
  ["localhost", "ngrok", "devtunnels"].some((h) => window.location.hostname.includes(h));

export const URL_api = () => {
  const urlApi = localStorage.getItem("gatewayUri"); // development !important

  return urlApi;
};

export const ServiceURL_GenerateReport = (recid) => {
  var base_url = URL_api();
  var serviceURL = `${base_url}reportapi/api/v1/Reporting/generatereportdatav2?id=${recid}`;
  // var serviceURL = `${base_url}reportapi/api/v1/Reporting/generatereportdata?id=${recid}`;
  // var environment = getEnvironment()
  // if (environment === 'Dev') {
  //  serviceURL = `${base_url}api/v1/Reporting/generatereportdata?id=${recid}`
  // }

  return serviceURL;
};

export const URL_Report = () => {
  var url = "";
  var encryptDecryptStorage = secureStorage();
  if (encryptDecryptStorage.getItem("systemSetting")) {
    // console.log('url_report dapat');
    // if(localStorage.getItem('systemSetting')) {
    var systemSetting = encryptDecryptStorage.getItem("systemSetting");
    // var systemSetting = JSON.parse(localStorage.getItem('systemSetting'))
    url = systemSetting.reportaddress;
  } else {
    url = "";
  }
  return url;
};

export const Email_Setting_Sender = () => {
  var email = "";
  var encryptDecryptStorage = secureStorage();
  if (encryptDecryptStorage.getItem("systemSetting")) {
    var systemSetting = encryptDecryptStorage.getItem("systemSetting");
    email = systemSetting.emailsettingsender;
  } else {
    email = "";
  }
  return email;
};

export const azureStorage = () => {
  var azure = {};

  // if(localStorage.getItem('systemSetting')) {
  //   var systemSetting = JSON.parse(localStorage.getItem('systemSetting'))

  var encryptDecryptStorage = secureStorage();
  if (encryptDecryptStorage.getItem("systemSetting")) {
    // console.log('azure storage dapat');
    // if(localStorage.getItem('systemSetting')) {
    var systemSetting = encryptDecryptStorage.getItem("systemSetting");
    // var systemSetting = JSON.parse(localStorage.getItem('systemSetting'))
    azure = {
      STORAGE_ACCOUNT_NAME: systemSetting.azureStorageaccountname,
      CONTAINER_NAME: systemSetting.azurecontainername,
      SAS_TOKEN: systemSetting.azurestoragetoken,
      sasURL: systemSetting.azureSASUri,
    };
  } else {
    azure = {
      STORAGE_ACCOUNT_NAME: "",
      CONTAINER_NAME: "",
      SAS_TOKEN: "",
      sasURL: "",
      // STORAGE_ACCOUNT_NAME: "hrmsstorageacc",
      // CONTAINER_NAME: "hrmsfile",
      // SAS_TOKEN:
      //   // "?sp=racwdl&st=2021-03-23T07:54:42Z&se=2025-12-31T07:54:00Z&sv=2020-02-10&sr=c&sig=BI4HAnbzGXVeAxo%2BvMtAUzU0OngxyR0R9bLVYkG2Kh8%3D",
      //   "sp=racwdl&st=2021-06-14T01:48:17Z&se=2028-06-14T09:48:17Z&sv=2020-02-10&sr=c&sig=KZob3NG2vqy%2FpHCt16m1GHvjR7CJ3ESYPmUVI7%2Bcx9E%3D",
      // sasURL:
      //   // "https://retailposstorage.blob.core.windows.net/?sp=racwdl&st=2021-03-23T06:29:58Z&se=2145-12-31T06:29:00Z&sv=2020-02-10&sr=c&sig=zC5KBCCoXQ9aUO0Nwd1fabrp0T4lwf3JNTH2YdR2ipM%3D",
      //   "https://hrmsstorageacc.blob.core.windows.net/?sp=racwdl&st=2021-06-14T01:48:17Z&se=2028-06-14T09:48:17Z&sv=2020-02-10&sr=c&sig=KZob3NG2vqy%2FpHCt16m1GHvjR7CJ3ESYPmUVI7%2Bcx9E%3D",
    };
  }

  return azure;
};

export const azureStorageCompany = () => {
  var azure = {};
  // if(localStorage.getItem('systemSetting')) {
  //   var systemSetting = JSON.parse(localStorage.getItem('systemSetting'))

  var encryptDecryptStorage = secureStorage();
  if (encryptDecryptStorage.getItem("systemSetting")) {
    // console.log('azure storage dapat');
    // if(localStorage.getItem('systemSetting')) {
    var systemSetting = encryptDecryptStorage.getItem("systemSetting");
    azure = {
      STORAGE_ACCOUNT_NAME: systemSetting.azureStorageaccountname,
      CONTAINER_NAME: systemSetting.azurecontainername,
      SAS_TOKEN: systemSetting.azurestoragetoken,
      sasURL: systemSetting.azureSASUri,
    };
  } else {
    azure = {
      STORAGE_ACCOUNT_NAME: "",
      CONTAINER_NAME: "",
      SAS_TOKEN: "",
      sasURL: "",
      // STORAGE_ACCOUNT_NAME: "hrmsstorageacc",
      // CONTAINER_NAME: "companypolicy",
      // SAS_TOKEN:
      //   "sp=racwdl&st=2021-08-23T05:22:15Z&se=2060-08-23T13:22:15Z&sv=2020-08-04&sr=c&sig=zmTD4BPTg1bsVi3ldVDvLzKmNaulKYIcw20l8lt0mPM%3D",
      // sasURL:
      //   "https://hrmsstorageacc.blob.core.windows.net/?sp=racwdl&st=2021-08-23T05:22:15Z&se=2060-08-23T13:22:15Z&sv=2020-08-04&sr=c&sig=zmTD4BPTg1bsVi3ldVDvLzKmNaulKYIcw20l8lt0mPM%3D",
    };
  }

  return azure;
};

// export const formatDate = (string) => {
//   var options = { year: "numeric", month: "long", day: "numeric" };
//   return new Date(string).toLocaleDateString([], options);
// };
export const openModalTarget = (id) => {
  return $(id).modal("show");
};
export const closeModalTarget = (id) => {
  return $(id).modal("hide");
};

/**
 * Converts a date string or Date object into a formatted date string using slashes ("/").
 *
 * @param {string | Date} date - The input date to format. Can be a date string or a Date object.
 * @returns {string} The formatted date string in the format "DD/MM/YYYY".
 *
 * @example
 * formatDate("2025-06-12"); // Returns "12/06/2025"
 * formatDate(new Date(2025, 5, 7)); // Returns "07/06/2025"
 *
 * @todo Would be better if renamed to formatDateSlash
 */
export const formatDate = (string) => {
  if (!string) {
    return "-";
  }

  let dateStr = string;

  if (typeof string === "string") {
    // some parameter are invalid
    // invalid parameter example: 2024-10-17T08:56:48.906211 00:00
    // found in detaildatachanges, Bug 2558
    const splitStr = string.split(" ");
    if (splitStr.length === 2) {
      dateStr = splitStr[0];
    }
  }

  var d = new Date(dateStr),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, month, year].join("/");
};

export const formatDateMonth = (string) => {
  if (!string) {
    return "-";
  }

  var d = new Date(string),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, month].join("/");
};
export const changeFormat = (string) => {
  var dt = string.split("/");
  var tgl = dt[1];
  var bulan = dt[0];
  var tahun = dt[2];
  return tgl + "/" + bulan + "/" + tahun;
};

export const formatDateStrip = (string) => {
  var d = new Date(string),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

export const currencyFormatIndo = (num) => {
  if (num === 0) return "0";
  if (num == null || isNaN(num)) return "-";

  const isNegative = num < 0;
  const absNum = Math.abs(num);
  const [intPart, decimalPart] = absNum.toString().split(".");

  // Format ribuan
  const formattedInt = intPart
    .split("")
    .reverse()
    .join("")
    .match(/\d{1,3}/g)
    .join(".")
    .split("")
    .reverse()
    .join("");

  // Hanya tampilkan desimal jika ada dan tidak hanya nol
  const formatted =
    decimalPart && Number(decimalPart) !== 0 ? `${formattedInt},${decimalPart}` : formattedInt;

  return isNegative ? `-${formatted}` : formatted;
};

export const removeCurrency = (string) => {
  var mystring = string.replace(/\./g, "");
  // eslint-disable-next-line no-useless-escape
  var cekFloat = mystring.replace(/\,/g, ".");
  var number = parseFloat(cekFloat);
  return number;
};
export const handleNumber = (e) => {
  let numb = e.target.value;
  let regex = /^[0-9\b]+$/;
  // if value is not blank, then test the regex
  if (numb === "" || regex.test(numb)) {
    return numb;
  }
};
export const formatNpwp = (value) => {
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/, "$1.$2.$3.$4-$5.$6");
};
export const formatNpwpToString = (value) => {
  var newStr = value.replaceAll(".", "");
  var txt = newStr.replaceAll("-", "");
  return txt;
};

export const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d);
};

export const formatDateIndo = (string) => {
  let bulan = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  var d = new Date(string),
    // month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    // year = d.getFullYear().toString().substr(-2);
    year = d.getFullYear().toString();

  var xbulan = d.getMonth();
  bulan = bulan[xbulan];

  // if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, bulan, year].join(" ");
};
export const formatDateEnglish = (string) => {
  let bulan = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  var d = new Date(string),
    // month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    // year = d.getFullYear().toString().substr(-2);
    year = d.getFullYear().toString();

  var xbulan = d.getMonth();
  bulan = bulan[xbulan];

  // if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, bulan, year].join(" ");
};

export const justDay = (string) => {
  var listHari = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var d = new Date(string),
    hr = d.getDay();
  var hari = listHari[hr];

  return hari;
};
export const formatDateDashboard = (string) => {
  var listbulan = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  var listHari = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  var d = new Date(string),
    day = "" + d.getDate(),
    hr = d.getDay(),
    year = d.getFullYear().toString();
  var hari = listHari[hr];
  var xbulan = d.getMonth();
  var bulan = listbulan[xbulan];

  // if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return `${hari}, ${day} ${bulan}`;
};
export const formatDateDashboardForEmployee = (string) => {
  var listbulan = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  var listHari = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  var d = new Date(string),
    day = "" + d.getDate(),
    hr = d.getDay(),
    month = "" + (d.getMonth() + 1),
    year = d.getFullYear().toString();
  // var hari = listHari[hr];
  var xbulan = d.getMonth();
  var bulan = listbulan[xbulan];

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return `${day} ${bulan} ${year}`;
};
export const formatDateMonthYear = (string, isLong = true) => {
  var listbulanLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  var listbulan = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  var d = new Date(string),
    month = "" + (d.getMonth() + 1),
    year = d.getFullYear().toString();
  // var hari = listHari[hr];
  var xbulan = d.getMonth();
  var bulan = isLong ? listbulanLong[xbulan] : listbulan[xbulan];

  if (month.length < 2) month = "0" + month;

  return `${bulan} ${year}`;
};
export const formatDateMonthYearNumber = (string) => {
  var listbulan = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

  var d = new Date(string),
    month = "" + (d.getMonth() + 1),
    year = d.getFullYear().toString();
  // var hari = listHari[hr];
  var xbulan = d.getMonth();
  var bulan = listbulan[xbulan];

  if (month.length < 2) month = "0" + month;

  return `${bulan}/${year}`;
};
export const formatDateBirthdayDashboard = (string) => {
  var listbulan = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  var listHari = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  var d = new Date(string),
    day = "" + d.getDate(),
    hr = d.getDay(),
    year = d.getFullYear().toString();
  var hari = listHari[hr];
  var xbulan = d.getMonth();
  var bulan = listbulan[xbulan];

  // if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return `${day} ${bulan}`;
};
export const formatDateDay = (string) => {
  var listbulan = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Ags",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var listHari = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  var d = new Date(string),
    day = "" + d.getDate(),
    hr = d.getDay(),
    year = d.getFullYear().toString();
  var hari = listHari[hr];
  var xbulan = d.getMonth();
  var bulan = listbulan[xbulan];

  // if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return `${hari}, ${day} ${bulan}`;
};
export const formatDateDayFull = (string) => {
  var listbulan = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Ags",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var listHari = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  var d = new Date(string),
    day = "" + d.getDate(),
    hr = d.getDay(),
    year = d.getFullYear().toString();
  var hari = listHari[hr];
  var xbulan = d.getMonth();
  var bulan = listbulan[xbulan];

  // if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return `${hari}, ${day} ${bulan} ${year}`;
};
export const formatDateDayFullTime = (string) => {
  var listbulan = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Ags",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var listHari = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  var d = new Date(string),
    day = "" + d.getDate(),
    hr = d.getDay(),
    year = d.getFullYear().toString();
  var hari = listHari[hr];
  var xbulan = d.getMonth();
  var bulan = listbulan[xbulan];

  var hour = d.getHours();
  var minutes = d.getMinutes();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);
  // console.log(hour, minutes);
  var time = `${hour}:${minutes}`;

  // if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return `${hari}, ${day} ${bulan} ${year} ${time}`;
};
export const formatDateDayFullTimeMinusSeven = (string) => {
  var listbulan = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Ags",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var listHari = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  var d = new Date(string);

  d.setHours(d.getHours() - 7);

  var day = "" + d.getDate(),
    hr = d.getDay(),
    year = d.getFullYear().toString();
  var hari = listHari[hr];
  var xbulan = d.getMonth();
  var bulan = listbulan[xbulan];

  var hour = d.getHours();
  var minutes = d.getMinutes();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);
  // console.log(hour, minutes);
  var time = `${hour}:${minutes}`;

  // if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return `${hari}, ${day} ${bulan} ${year} ${time}`;
};

export const formatDateTimeIndo = (string) => {
  var d = new Date(string);
  var date = formatDateIndo(d);
  var hour = d.getHours();
  var minutes = d.getMinutes();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);
  // console.log(hour, minutes);
  var time = `${hour}:${minutes}`;

  return date + " " + time;
};

export const formatDateTimePlus = (string) => {
  var d = new Date(string),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  var hour = d.getHours();
  var minutes = d.getMinutes();
  var second = d.getSeconds();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);
  second = ("0" + second).slice(-2);

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  var tanggal = [day, month, year].join("/");
  var waktu = `${hour}:${minutes}:${second}`;

  return `${tanggal} ${waktu}`;
};
export const formatDateTimePlusStrip = (string) => {
  var d = new Date(string),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  var hour = d.getHours();
  var minutes = d.getMinutes();
  var second = d.getSeconds();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);
  second = ("0" + second).slice(-2);

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  var tanggal = [year, month, day].join("-");
  var waktu = `${hour}:${minutes}:${second}`;

  return `${tanggal} ${waktu}`;
};

export const formatDateTime = (string) => {
  if (!string) {
    return "-";
  }

  var d = new Date(string);
  var date = formatDate(d);
  var hour = d.getHours();
  var minutes = d.getMinutes();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);
  // console.log(hour, minutes);
  var time = `${hour}:${minutes}`;

  return date + " " + time;
};

const WibOffset = (date = new Date()) => {
  // Offset WIB (UTC+7) dalam milidetik
  const wibOffsetMs = 7 * 60 * 60 * 1000;

  // Ambil waktu UTC dan tambahkan offset WIB
  const localTime = new Date(date.getTime() + wibOffsetMs);

  // Format ke string datetime lokal WIB: YYYY-MM-DD HH:MM:SS

  return localTime;
};

export const formatDateTimeWibOffset = (string) => {
  if (!string) {
    return "-";
  }
  var d = new Date(string);
  const convertToWib = WibOffset(d);
  var date = formatDate(convertToWib);
  var hour = convertToWib.getHours();
  var minutes = convertToWib.getMinutes();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);
  // console.log(hour, minutes);
  var time = `${hour}:${minutes}`;

  return date + " " + time;
};
export const formatTimeIndo = (string) => {
  var d = new Date(string);
  var hour = d.getHours();
  var minutes = d.getMinutes();
  hour = ("0" + hour).slice(-2);
  minutes = ("0" + minutes).slice(-2);
  // console.log(hour, minutes);
  var time = `${hour}:${minutes}`;
  return time;
};

/**
 * Formats a Date object into an ISO 8601 string (YYYY-MM-DDTHH:mm:ss)
 * using the local time, without applying or converting to UTC.
 *
 * @param {Date | string} dateString - The JavaScript Date object to format.
 * @returns {string} The formatted local ISO 8601 string without timezone offset.
 *
 * @example
 * const date = new Date();
 * const isoString = formatISO8601(date);
 * // "2025-05-20T22:15:00"
 */
export const formatISO8601 = (dateString) => {
  let date = new Date(dateString);
  if (isNaN(date.getTime())) {
    date = new Date();
  }

  const pad = (num, padLength = 2) => String(num).padStart(padLength, "0");

  const year = pad(date.getFullYear(), 4);
  const month = pad(date.getMonth() + 1); // Month is 0-based
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

/**
 * Returns the given string if it is non-empty; otherwise returns a fallback string.
 *
 * @param {string} string - The string to check (can be null, undefined, or an empty string).
 * @param {string | any} [fallbackValue="-"] - The fallback value to return if the input is empty.
 * @returns {string | any} The original string if not empty; otherwise the fallback string.
 *
 * @example
 * handleEmptyString("", "-");
 * // Returns "-"
 *
 * @example
 * handleEmptyString("Hello");
 * // Returns "Hello"
 */
export const handleEmptyString = (string, fallbackValue = "-") => {
  const invalidStrings = ["", "null", "undefined"];
  if (typeof string === "string" && !invalidStrings.includes(string.trim().toLowerCase())) {
    return string;
  }
  return fallbackValue;
};

/**
 * Returns the minimum date used as a placeholder or default.
 * This is typically used to represent an uninitialized or empty date value.
 * @returns {string} ISO date string "0001-01-01T00:00:00"
 */
export const getEmptyDate = () => {
  return "0001-01-01T00:00:00";
};

/**
 * Formats a Date object as a time string in HH:mm format.
 * @param {string} [string=null] - The date string to format.
 * @returns {string} The formatted time string (e.g., "22:00").
 */
export const getHoursMinutes = (string = null) => {
  if (!string) {
    return "-";
  }
  const date = new Date(string);
  const hours = date.getHours().toString().padStart(2, "0"); // Get hours as a 2-digit string
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Get minutes as a 2-digit string
  return `${hours}:${minutes}`;
};

/**
 * Get midnight time formatted as a time string in HH:mm format.
 * @returns {string} The formatted midnight time string ("00:00").
 */
export const getMidnightTime = () => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const getHoursValue = (string) => {
  var str = string.split(":");
  var hour = str[0];
  return parseInt(hour);
};

/**
 * Returns the first and last day of a specified year.
 * If no year is provided, defaults to the current year.
 *
 * @param {number} [year] - The year for which to get the boundaries. Defaults to the current year.
 * @returns {{ firstDay: Date, lastDay: Date }} An object containing the first and last day of the year as Date objects.
 *
 * @example
 * getFirstAndLastDay(2025);
 * // => { firstDay: Date('2025-01-01'), lastDay: Date('2025-12-31') }
 *
 * @example
 * getFirstAndLastDay();
 * // => uses the current year
 */
export const getFirstAndLastDay = (year = new Date().getFullYear()) => {
  const firstDay = new Date(year, 0, 1); // 1st of January
  const lastDay = new Date(year, 11, 31); // 31st of December

  return {
    firstDay,
    lastDay,
  };
};

export const capitalizeTheFirstLetterOfEachWord = (words) => {
  if (words) {
    const separateWord = words.toLowerCase().split(" ");
    for (var i = 0; i < separateWord.length; i++) {
      separateWord[i] = separateWord[i].charAt(0).toUpperCase() + separateWord[i].substring(1);
    }
    return separateWord.join(" ");
  } else {
    return "";
  }
};
export const getTwoWeeksRange = (date) => {
  // var dt = new Date(Date.now() + 12096e5);
  let now = new Date(date);
  now.setDate(now.getDate() + 14);
  return now;
};
export const getDateRange = (date, totals) => {
  // var dt = new Date(Date.now() + 12096e5);
  const nb = totals - 1;
  let now = new Date(date);
  now.setDate(now.getDate() + nb);
  return now;
};
export const getOneMonthRange = (date) => {
  // var dt = new Date(Date.now() + 12096e5);
  let now = new Date(date);
  now.setMonth(now.getMonth() + 1);
  return now;
};
export const getOneYearRange = (date) => {
  // var dt = new Date(Date.now() + 12096e5);
  let now = new Date(date);
  now.setFullYear(now.getFullYear() + 1);
  return now;
};
export const getTwoWeeksRangeMinus = (date) => {
  // var dt = new Date(Date.now() + 12096e5);
  let now = new Date(date);
  now.setDate(now.getDate() - 14);
  return now;
};
export const getOneMonthRangeMinus = (date) => {
  // var dt = new Date(Date.now() + 12096e5);
  let now = new Date(date);
  now.setMonth(now.getMonth() - 1);
  return now;
};
export const getOneYearRangeMinus = (date) => {
  // var dt = new Date(Date.now() + 12096e5);
  let now = new Date(date);
  now.setFullYear(now.getFullYear() - 1);
  return now;
};
export const getPreviousYearDefaultJanuary = (date) => {
  var d = new Date(date),
    month = "01",
    day = "01",
    year = "" + (d.getFullYear() - 1);

  return [year, month, day].join("-");
};
export const getPreviousYearDefault = (date) => {
  // var dt = new Date(Date.now() + 12096e5);
  // let now = new Date(date);
  // now.setDate(now.getDate() - 31);

  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = "" + (d.getFullYear() - 1);

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");

  // return [year, month, day].join("-");
};
export const getTwoMonthMinus = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() - 1),
    day = "" + d.getDate(),
    year = "" + d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  // return [year, month, day].join("-");
  return `${year}${month}-${day}`;

  // return [year, month, day].join("-");
};

const statusMap = {
  primary: ["in review", "executing", "started", "on hold", "on progress", "monitoring"],

  info: ["selection", "interview", "negotiation", "open"],

  light: ["closed", "close"],

  warning: ["received", "no offer made"],

  danger: [
    "offer rejected",
    "rejected",
    "reject",
    "failed",
    "error",
    "non active",
    "cancelled",
    "canceled",
    "no",
    "not sent",
  ],

  success: [
    "hire",
    "success",
    "active",
    "offer approved",
    "hired",
    "completed",
    "accept",
    "hire new worker",
    "employed",
    "finished",
    "confirmed",
    "approved",
    "yes",
    "sent",
    "pass",
  ],
};

export const renderStatus = (status) => {
  if (status === null || status === undefined || status === "") {
    return "-";
  }

  const value = String(status).toLowerCase();

  if (value === "true") {
    return <span className="badge bg-inverse-success">Active</span>;
  }

  if (value === "false") {
    return <span className="badge bg-inverse-danger">Not Active</span>;
  }

  if (value === "1") {
    return <span className="badge bg-inverse-success">Yes</span>;
  }

  if (value === "0") {
    return <span className="badge bg-inverse-danger">No</span>;
  }

  // Handle mapped groups
  for (const [style, keywords] of Object.entries(statusMap)) {
    if (keywords.includes(value)) {
      return <span className={`badge bg-inverse-${style}`}>{status}</span>;
    }
  }

  // Default case
  return <span className="badge bg-inverse-warning">{status}</span>;
};

export const renderRatingLines = (rating) => {
  switch (String(rating).toLowerCase()) {
    case "a+":
      return <span className="badge bg-inverse-success radius-border-badge-lines">{rating}</span>;
    case "a":
      return <span className="badge bg-inverse-success radius-border-badge-lines">{rating}</span>;
    case "a-":
      return <span className="badge bg-inverse-success radius-border-badge-lines">{rating}</span>;
    case "b+":
      return <span className="badge bg-inverse-primary radius-border-badge-lines">{rating}</span>;
    case "b":
      return <span className="badge bg-inverse-primary radius-border-badge-lines">{rating}</span>;
    case "b-":
      return <span className="badge bg-inverse-primary radius-border-badge-lines">{rating}</span>;
    case "c+":
      return <span className="badge bg-inverse-warning radius-border-badge-lines">{rating}</span>;
    case "c":
      return <span className="badge bg-inverse-warning radius-border-badge-lines">{rating}</span>;
    case "c-":
      return <span className="badge bg-inverse-warning radius-border-badge-lines">{rating}</span>;
    case "d+":
      return <span className="badge bg-inverse-danger radius-border-badge-lines">{rating}</span>;
    case "d":
      return <span className="badge bg-inverse-danger radius-border-badge-lines">{rating}</span>;
    case "d-":
      return <span className="badge bg-inverse-danger radius-border-badge-lines">{rating}</span>;
    case "high":
      return <span className="badge bg-inverse-success radius-border-badge-lines">{rating}</span>;
    case "medium":
      return <span className="badge bg-inverse-warning radius-border-badge-lines">{rating}</span>;
    case "low":
      return <span className="badge bg-inverse-danger radius-border-badge-lines">{rating}</span>;
  }
};
export const renderRatingHeader = (rating) => {
  const ratingCase = String(rating).toLowerCase();
  switch (ratingCase) {
    case "a+":
      return (
        <span
          className="badge bg-inverse-success text-a"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#26af48" }}>A+</h3>
        </span>
      );
    case "a":
      return (
        <span
          className="badge bg-inverse-success text-a"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#26af48" }}>A</h3>
        </span>
      );
    case "a-":
      return (
        <span
          className="badge bg-inverse-success text-a"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#26af48" }}>A-</h3>
        </span>
      );
    case "b+":
      return (
        <span
          className="badge bg-inverse-primary text-b"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#4d8af0" }}>B+</h3>
        </span>
      );
    case "b":
      return (
        <span
          className="badge bg-inverse-primary text-b"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#4d8af0" }}>B</h3>
        </span>
      );
    case "b-":
      return (
        <span
          className="badge bg-inverse-primary text-b"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#4d8af0" }}>B-</h3>
        </span>
      );
    case "c+":
      return (
        <span
          className="badge bg-inverse-warning text-c"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#f39c12" }}>C+</h3>
        </span>
      );
    case "c":
      return (
        <span
          className="badge bg-inverse-warning text-c"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#f39c12" }}>C</h3>
        </span>
      );
    case "c-":
      return (
        <span
          className="badge bg-inverse-warning text-c"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#f39c12" }}>C-</h3>
        </span>
      );
    case "d+":
      return (
        <span
          className="badge bg-inverse-danger text-d"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#e63c3c" }}>D+</h3>
        </span>
      );
    case "d":
      return (
        <span
          className="badge bg-inverse-danger text-d"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#e63c3c" }}>D</h3>
        </span>
      );
    case "d-":
      return (
        <span
          className="badge bg-inverse-danger text-d"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#e63c3c" }}>D-</h3>
        </span>
      );
    default:
      return (
        <span
          className="badge bg-inverse-primary text-d"
          style={{ borderRadius: "50%", padding: "15px", width: "55px", aspectRatio: "1" }}
        >
          <h3 style={{ margin: 0, color: "#4d8af0" }}>{ratingCase.toLocaleUpperCase()}</h3>
        </span>
      );
  }
};
export const datesAreOnSameDay = (first, second) => {
  return (
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate()
  );
};
export const getMonthDropdown = () => {
  const dt = [
    {
      value: 1,
      label: "January",
      labelPendek: "Jan",
    },
    {
      value: 2,
      label: "February",
      labelPendek: "Feb",
    },
    {
      value: 3,
      label: "March",
      labelPendek: "Mar",
    },
    {
      value: 4,
      label: "April",
      labelPendek: "Apr",
    },
    {
      value: 5,
      label: "May",
      labelPendek: "May",
    },
    {
      value: 6,
      label: "June",
      labelPendek: "Jun",
    },
    {
      value: 7,
      label: "July",
      labelPendek: "Jul",
    },
    {
      value: 8,
      label: "August",
      labelPendek: "Aug",
    },
    {
      value: 9,
      label: "September",
      labelPendek: "Sep",
    },
    {
      value: 10,
      label: "October",
      labelPendek: "Oct",
    },
    {
      value: 11,
      label: "November",
      labelPendek: "Nov",
    },
    {
      value: 12,
      label: "December",
      labelPendek: "Des",
    },
  ];

  return dt;
};
export const removeSpecialCharacter = (text) => {
  var deleteSpecialCharacter = text
    .replace(/’/g, "&#8217;")
    .replace(/“/g, "&#8220;")
    .replace(/”/g, "&#8221;")
    // .replace(/é/g, "e")
    .replace(/é/g, "&#233;")
    .replace(/‘/g, "&#8216;");
  return deleteSpecialCharacter;
};
export const importSpecialCharacter = (text) => {
  var deleteSpecialCharacter = text
    .replace(/&#8217;/g, "’")
    .replace(/&#8220;/g, "“")
    .replace(/&#8221;/g, "”")
    // .replace(/é/g, "e")
    .replace(/&#233;/g, "é")
    .replace(/&#8216;/g, "‘");
  return deleteSpecialCharacter;
};

export const formatNumberWithCommas = (num) => {
  if (!num) return num;

  const [integerPart, fractionalPart] = num.toString().split("."); // Split into integer and fractional parts

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Format integer part

  return fractionalPart ? `${formattedInteger},${fractionalPart}` : formattedInteger;
};

export const formatNumberWithoutComma = (num) => {
  if (num) {
    return num?.split(".").join("");
  } else {
    return num;
  }
};

export const debounce = (func, delay) => {
  let timeoutId;

  return (...args) => {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const formatNumberTwoComma = (value) => {
  const stringValue = formatNumberWithoutComma(value.toString());

  if (stringValue.length >= 3) {
    const formattedValue =
      stringValue.slice(0, -2) +
      "." +
      stringValue.slice(-2).replace(/(\d)(?=(\d{2})+(\d|$))/g, "$1.");

    return formattedValue;
  }

  return stringValue;
};

export const handleChangeState = (key, value, func) => {
  func((prev) => ({
    ...prev,
    [key]: value,
  }));
};

export const removeDuplicatesArrayOfObject = (arr, prop) => {
  const unique = new Set();
  const filteredArray = arr.filter((item) => {
    const key = item[prop];
    return unique.has(key) ? false : unique.add(key);
  });

  return filteredArray;
};

export const formatTextDateNever = (date, funcFormat) => {
  if (date) {
    const year = new Date(date)?.getFullYear();

    if (year >= 2154) {
      return "Never";
    } else if (funcFormat) {
      return funcFormat(date);
    } else {
      return date;
    }
  } else {
    return date;
  }
};

export const downloadExcelFile = (response, data, nameFile, typeFile = "xlsx") => {
  // Buat Blob dari data respons
  const blob = new Blob([data], { type: response.headers["content-type"] });

  // Buat URL objek dari Blob
  const url = URL.createObjectURL(blob);

  // Buat elemen 'a' dan tetapkan href-nya ke URL objek
  const a = document.createElement("a");
  a.href = url;

  // Tetapkan nama file yang diinginkan
  a.download = `${nameFile}.${typeFile}`;

  // Programmatically klik elemen 'a' untuk memulai unduhan
  document.body.appendChild(a);
  a.click();

  // Hapus elemen 'a' dari DOM setelah unduhan
  document.body.removeChild(a);

  // Hapus URL objek untuk membersihkan sumber daya
  URL.revokeObjectURL(url);
};

export const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (char) {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

export const truncateText = (text, maxLength = 4) => {
  if (!text) return "";
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};
export const lookupWorkerName = (justWorkerActive, activeWorker, inactiveWorker, worker) => {
  let text = "";
  if (justWorkerActive) {
    if (activeWorker.length) {
      let filterS1 = activeWorker.filter((obj) => obj.value === worker);
      if (filterS1.length) {
        text = filterS1[0].firstname + " " + filterS1[0].middlename + " " + filterS1[0].lastname;
      }
    }
  } else {
    if (activeWorker.length && inactiveWorker.length) {
      let filterS1 = activeWorker.filter((obj) => obj.value === worker);
      let filterS2 = inactiveWorker.filter((obj) => obj.value === worker);
      if (filterS1.length) {
        text = filterS1[0].firstname + " " + filterS1[0].middlename + " " + filterS1[0].lastname;
      }
      if (filterS2.length) {
        text = filterS2[0].firstname + " " + filterS2[0].middlename + " " + filterS2[0].lastname;
      }
    }
  }
  return text;
};

export const lookupPersonnelNumber = (justWorkerActive, activeWorker, inactiveWorker, worker) => {
  let text = "";
  if (justWorkerActive) {
    if (activeWorker.length) {
      let filterS1 = activeWorker.filter((obj) => obj.value === worker);
      if (filterS1.length) {
        text = filterS1[0].personnelNumber;
      }
    }
  } else {
    if (activeWorker.length && inactiveWorker.length) {
      let filterS1 = activeWorker.filter((obj) => obj.value === worker);
      let filterS2 = inactiveWorker.filter((obj) => obj.value === worker);
      if (filterS1.length) {
        text = filterS1[0].personnelNumber;
      }
      if (filterS2.length) {
        text = filterS2[0].personnelNumber;
      }
    }
  }
  return text;
};

export const filterMenusFromArray = (data) => {
  return data.map((module) => {
    const filteredChildren = (module?.children || [])
      .map(function filter(node) {
        if (node.types !== "Menu") return null;

        return {
          ...node,
          children: (node.children || []).map(filter).filter(Boolean),
        };
      })
      .filter(Boolean);

    return {
      ...module,
      children: filteredChildren,
    };
  });
};

export function formatPercent(value, options = {}) {
  const {
    locale = "en-US", // atau 'id-ID' untuk format Indonesia
    maxDigits = 2, // maksimal angka di belakang koma
    minDigits = 0, // minimal angka di belakang koma
  } = options;

  if (typeof value !== "number" || isNaN(value)) return "";

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
  }).format(value);
}

/**
 * Global handler untuk error dari API call.
 *
 * @param {Object} error - Error object dari Axios atau fetch.
 * @param {string} path - Nama file atau komponen yang memanggil API (untuk logging).
 * @param {string} api - Nama atau path API yang dipanggil.
 * @param {boolean} [showToast=true] - Apakah tampilkan error ke user via toast.
 * @param {string} [cutomMsgErr] - Pesan custom jika API tidak mengembalikan pesan.
 *
 * @returns {void} - Tidak mengembalikan nilai, hanya menampilkan toast (opsional) dan logging error.
 *
 * @example
 * try {
 *   const res = await axios.get("/api/v1/users");
 * } catch (error) {
 *   handleCatchFromAPI(error, "UserList.jsx", "GetUsers");
 * }
 */
export function handleCatchFromAPI(error, path, api, showToast = true, cutomMsgErr) {
  // pesan dari API (kalau ada)
  const apiMessage =
    cutomMsgErr ||
    error?.response?.data?.detail ||
    error?.response?.data?.title ||
    error?.message ||
    error ||
    "Unknown error";

  // tampilkan ke user (toast/alert)
  if (showToast) toast.error(apiMessage);

  // log detail untuk developer
  console.error(`[${path}] API ${api} failed: `, {
    message: apiMessage,
    status: error?.response?.status || "No Status",
    data: error?.response?.data || error,
    stack: error?.stack,
    errorDetail: error,
  });
}

/**
 * Exclude keys dari object
 * @param {Object} obj - object asal
 * @param {string[]} keys - daftar key yang mau di-exclude
 * @returns {Object} object baru tanpa key tertentu
 *
 * @example
 * const a = { name: "John", password: "123", email: "john@example.com" };
 * const b = excludeKeys(a, ["password"]);
 * // { name: "John", email: "john@example.com" }
 */
export function excludeKeys(obj, keys = []) {
  return Object.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key)));
}

/**
 * Format a time string or Dayjs object into "HH:mm"
 * @param {string|object} time - input time, e.g. "08:00:00" or a Dayjs object
 * @returns {string} formatted time in "HH:mm"
 */
export function formatTimeToHHmm(time) {
  if (!time) return "";
  return dayjs.isDayjs(time)
    ? time.format("HH:mm")
    : dayjs(time, ["HH:mm:ss", "HH:mm"]).format("HH:mm");
}

/**
 * Copy any JS object/array/string into clipboard
 * - Will stringify if object/array
 * - Limit: recommended under ~2MB
 *
 * @param {any} data - The data to copy
 * @param {boolean} pretty - Whether to format with indentation
 */
export async function copyToClipboard(data, pretty = true) {
  try {
    let text;
    if (typeof data === "object") {
      text = JSON.stringify(data, null, pretty ? 2 : 0);
    } else {
      text = String(data);
    }

    const sizeInKB = new Blob([text]).size / 2048; // 2 MB
    if (sizeInKB > 2048) {
      console.warn(`⚠️ Data is ${Math.round(sizeInKB)} KB, might be too large for clipboard.`);
    }

    await navigator.clipboard.writeText(text);
    // eslint-disable-next-line no-console
    console.info("✅ Data copied to clipboard successfully!");
  } catch (err) {
    console.error("❌ Failed to copy to clipboard:", err);
  }
}

/**
 * Paste text from clipboard.
 * If it's valid JSON, will return parsed object,
 * otherwise return raw string.
 *
 * @returns {Promise<any>} Parsed object or raw string
 */
export async function pasteFromClipboard() {
  try {
    const text = await navigator.clipboard.readText();
    // eslint-disable-next-line no-console
    console.info("📋 Data pasted from clipboard");

    try {
      return JSON.parse(text); // coba parse JSON
    } catch {
      return text; // kalau bukan JSON, balikin string asli
    }
  } catch (err) {
    console.error("❌ Failed to paste from clipboard:", err);
    return "";
  }
}

/**
 * Generate array of dates between start and end (inclusive)
 * @param {string|Date|dayjs.Dayjs} startDate - start date
 * @param {string|Date|dayjs.Dayjs} endDate - end date
 * @param {string} format - output date format (default: "YYYY-MM-DD")
 * @returns {string[]} array of date strings
 */
export function getDateRangeArray(startDate, endDate, format = "YYYY-MM-DD") {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const range = [];

  let current = start;
  while (current.isSameOrBefore(end, "day")) {
    range.push(current.format(format));
    current = current.add(1, "day");
  }

  return range;
}

/**
 * Get current version from .env
 * @returns {string} current version from .env
 */
export function getEnvVersion() {
  return process.env.REACT_APP_VERSION;
}

/**
 * Preserve essential localStorage keys, clear the rest
 *
 * Clear cookies "redirectFromEmail"
 */
export function clearLocalStoragePreserveEssentials() {
  const themeColor = localStorage.getItem("themeColor");
  const listFavoriteStorage = localStorage.getItem("listFavoriteStorage");
  const currentVersion = localStorage.getItem("versionsapp");
  // Preserve pkce_code_verifier so the Identity Server PKCE flow is not broken
  // if this function is called mid-authentication (e.g., during /signin-oidc).
  const pkceCodeVerifier = localStorage.getItem("pkce_code_verifier");
  const envVersion = getEnvVersion();

  localStorage.clear();
  Object.keys(Cookies.get()).forEach((cookie) => {
    Cookies.remove(cookie);
  });

  if (pkceCodeVerifier) localStorage.setItem("pkce_code_verifier", pkceCodeVerifier);

  if (themeColor) localStorage.setItem("themeColor", themeColor);
  if (listFavoriteStorage) localStorage.setItem("listFavoriteStorage", listFavoriteStorage);

  // Don't compare versions as strings ("2.10.0" < "2.9.0" → true).
  // Use semantic version comparison with `semver` instead.
  // The version defined in .env represents the currently deployed build.
  if (!currentVersion || semver.neq(currentVersion, envVersion)) {
    localStorage.setItem("versionsapp", envVersion);
  }
}

/**
 * Clears all Service Worker caches (Cache Storage API).
 * Use this to remove stale assets/API responses cached by the SW.
 *
 * @returns {Promise<void>}
 *
 * @example
 * await clearServiceWorkerCaches();
 */
export async function clearServiceWorkerCaches() {
  if (!("caches" in window)) return;

  try {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));
    console.info("[cache] All Service Worker caches cleared.");
  } catch (err) {
    console.error("[cache] Failed to clear SW caches:", err);
  }
}

/**
 * Detects when the app version (REACT_APP_VERSION) changes between sessions.
 * If a version change is detected (e.g., 10.3.9 → 10.3.10), it:
 *  1. Clears all localStorage & cookies (via clearLocalStoragePreserveEssentials)
 *  2. Clears all Service Worker caches
 *  3. Stores the current version stamp so the next visit is clean
 *
 * Call this once at app startup (e.g., in App.jsx or index.js).
 *
 * @returns {Promise<boolean>} true if a version change was detected and cleanup ran
 *
 * @example
 * // In App.jsx
 * useEffect(() => {
 *   checkAndHandleEnvChange();
 * }, []);
 */
export async function checkAndHandleEnvChange() {
  const currentVersion = getEnvVersion();
  const storedVersion = localStorage.getItem("versionsapp");

  // semver.coerce handles non-strict versions like "10.1" → "10.1.0"
  const parsedStored = semver.coerce(storedVersion);
  const parsedCurrent = semver.coerce(currentVersion);

  const hasVersionChanged =
    storedVersion && parsedStored && parsedCurrent && semver.neq(parsedStored, parsedCurrent);

  if (hasVersionChanged) {
    // Guard against SW-induced infinite reload loop.
    // sessionStorage survives a soft reload but is NOT cleared by localStorage.clear(),
    // so it acts as a "we already reloaded once for this version" flag.
    const justReloaded = sessionStorage.getItem("versionReloadGuard") === currentVersion;

    if (justReloaded) {
      // Already reloaded once for this version — SW must be fully updated now.
      // Just stamp the version and continue normally.
      localStorage.setItem("versionsapp", currentVersion);
      sessionStorage.removeItem("versionReloadGuard");
      console.info(`[env-guard] Post-reload cleanup done. Version stamped: ${currentVersion}`);
      return false;
    }

    console.warn(
      `[env-guard] Version changed: "${storedVersion}" → "${currentVersion}". Clearing stale cache.`
    );

    clearLocalStoragePreserveEssentials();
    await clearServiceWorkerCaches();

    // Unregister all SW registrations so the browser fetches the new bundle from server.
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((reg) => reg.unregister()));
    }

    // Set reload guard before reloading (sessionStorage persists through reload).
    sessionStorage.setItem("versionReloadGuard", currentVersion);

    // Hard reload — bypasses SW cache, fetches fresh bundle from server.
    window.location.reload();
    return true;
  }

  // First visit — stamp it
  if (!storedVersion) {
    localStorage.setItem("versionsapp", currentVersion);
  }

  return false;
}

/**
 * 🧹 Trim and remove extra spaces between words
 */
export const cleanSpaces = (text) => {
  if (typeof text !== "string") return text;
  return text.trim().replace(/\s+/g, " ");
};

/**
 * Navigates back in the browser history if possible, otherwise pushes to a fallback URL.
 *
 * This function checks if there is more than one entry in the browser's history stack.
 * If yes, it uses React Router's history.goBack() to navigate to the previous page.
 * If not, it pushes to the provided fallback URL (defaulting to "/").
 *
 * @param {Object} history - The history object from React Router (e.g., from useHistory hook).
 * @param {string} [url="/"] - The fallback URL to navigate to if no previous history exists.
 *
 * @example
 * // In a React component
 * import { useHistory } from 'react-router-dom';
 * import { goBackHistory } from './utility/util';
 *
 * const MyComponent = () => {
 *   const history = useHistory();
 *
 *   const handleBack = () => {
 *     goBackHistory(history, '/dashboard');
 *   };
 *
 *   return <button onClick={handleBack}>Go Back</button>;
 * };
 */
export const goBackHistory = (history, url = "/") => {
  if (window.history.length > 1) {
    history.goBack();
  } else {
    history.push(url);
  }
};

/**
 * Create URL with query parameters safely.
 * @param {string} base - Base URL (without query)
 * @param {object} params - Object containing query params
 * @returns {string} Full URL with encoded query string
 */
export function createQueryURL(base, params = {}) {
  const query = Object.entries(params)
    .map(([key, value]) => `${key}=${encryptData(value)}`)
    .join("&");

  return query ? `${base}?${query}` : base;
}

/**
 * Build a query string where array values are encoded as repeated keys.
 * @param {object} params - Object containing query params
 * Example: { a: [1,2], b: 3 } => 'a=1&a=2&b=3'
 */
export function buildQueryFromParams(params) {
  if (!params) return "";
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== null && v !== undefined) searchParams.append(key, v);
      });
    } else {
      searchParams.append(key, value);
    }
  });
  return searchParams.toString();
}

/**
 * Generate a color palette from a theme color in dashboard
 * @param {string} themeColor - Hex color code (e.g., '#002966')
 * @returns {string[]} Array of 5 distinct colors
 */
export const generateColorPalette = (color) => {
  // Check if client is ASABRI and return static colors
  const callTenant = localStorage.getItem("tenantid");
  if (callTenant === TENANT_ID.ASABRI) {
    return ["#002966", "#cca600", "#732C2C", "#F46036", "#1B998B"];
  }

  // Dynamic color generation for other clients
  const themeColor = localStorage.getItem("themeColor");
  const tenantColor = localStorage.getItem("tenantTheme");

  const finalColor = color || themeColor || tenantColor || "#0273BB";

  // Convert hex to RGB
  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  };

  // Convert RGB to HSL
  const rgbToHsl = (r, g, b) => {
    ((r /= 255), (g /= 255), (b /= 255));
    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
          break;
        case g:
          h = ((b - r) / d + 2) / 6;
          break;
        case b:
          h = ((r - g) / d + 4) / 6;
          break;
      }
    }
    return [h, s, l];
  };

  // Convert HSL to RGB
  const hslToRgb = (h, s, l) => {
    let r, g, b;

    if (s === 0) {
      r = g = b = l;
    } else {
      const hue2rgb = (p, q, t) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };

      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
  };

  // RGB to Hex
  const rgbToHex = (r, g, b) => {
    return (
      "#" +
      [r, g, b]
        .map((x) => {
          const hex = x.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        })
        .join("")
    );
  };

  const rgb = hexToRgb(finalColor);
  const [h, s, l] = rgbToHsl(rgb.r, rgb.g, rgb.b);

  const variants = [
    [0.15, 0.2, -0.3], // Darker variant
    [0.33, 0.15, 0.2], // Lighter complementary
    [0.5, 0.25, 0], // Opposite hue
    [-0.25, 0.2, 0.15], // Analogous warm
    [0.08, 0.1, -0.1], // Subtle shift
    [0.25, 0.3, 0.15], // Bright variant
    [0.42, 0.25, -0.2], // Muted variant
    [0.58, 0.15, 0.25], // Light blue-green
    [-0.15, 0.2, -0.1], // Analogous cool
    [-0.33, 0.3, 0.1], // Split complementary
    [-0.42, 0.25, -0.25], // Deep variant
    [0.75, 0.1, 0.2], // Pastel variant
    [0.9, 0.2, -0.2], // Red variant
    [0, 0.3, 0.3], // Pale variant
    [0, -0.2, -0.3], // Dark muted
    [0.67, 0.2, 0.15], // Cyan variant
    [-0.58, 0.25, -0.15], // Purple variant
    [0.17, -0.15, 0.25], // Desaturated light
    [-0.08, 0.35, -0.25], // Deep saturated
    [0.33, 0.1, -0.2], // Muted cool
  ];

  const generateVariant = (hueShift, satMod, lightMod) => {
    const newH = (h + hueShift) % 1;
    const newS = Math.min(s + satMod, 1);
    const newL = Math.max(Math.min(l + lightMod, 0.9), 0.1);
    return rgbToHex(...hslToRgb(newH, newS, newL));
  };

  return [
    finalColor,
    ...variants.map(([hShift, sMod, lMod]) => generateVariant(hShift, sMod, lMod)),
  ];
};
